import {createApp} from 'vue';
import App from './App.vue';
import mitt from 'mitt';

document.addEventListener("DOMContentLoaded", (event) => {

    const emitter = mitt();
    const mediathekApp = createApp(App).mixin({
        methods: {
            boldIt(str, needle) {
                let strRegExp = new RegExp(`(${needle})`, 'ig');
                return str.replace(strRegExp, `<b>$1</b>`);
            },
            /**
             * fix date string to work also with safari properly
             *
             * example not working in Safari: new Date('2022-02-17 00:00:00.000000')
             * example should work on all browsers: new Date('2022-02-17T00:00:00.000000')
             *
             * @param date
             * @returns {*}
             */
            fixDateString(date) {
                return date.split(' ').join('T');
            }
        },
        filters: {
            striphtml: function (string) {
                return string.replace(/<\/?[^>]+>/ig, " ");
            }
        }
    });

    mediathekApp.config.globalProperties.emitter = emitter;
    mediathekApp
        .mount('#app-root');

    window.SK = window.SK || {};
    window.SK.mediathekApp = mediathekApp;
});